class IssuedCertificate {
	id = null;
	certificate_number = null;
	planned_course_id = null;
	candidate_id = null;
	certificate_id = null;
	course_id = null;
	certificate_type = 'dva_potpisa';
	issued_in = null;
	provisions = '';
	held_in = null;
	start_date = null;
	end_date = null;
	expiration_date = null;
	issue_date = null;
	office_id = null;
	unlimited_validity = false;
	active = true;
	certificate_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default IssuedCertificate;
